import React, { Component } from "react";

class Header extends Component {
  render() {
    const { activePage, onMenuClick } = this.props;

    return (
      <div className="header">

        {/* ✅ Hamburger menu button (mobile only) */}
        <button className="header-menu-btn" onClick={onMenuClick} aria-label="Open menu">
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Left: Current Page Title */}
        <h3>{activePage}</h3>

        {/* Right: Admin Info */}
        <div className="header-right">
          <span>Hi, Admin</span>
          <div className="header-avatar">A</div>
        </div>

      </div>
    );
  }
}

export default Header;
